export const language: any = {
  selected_ingredients: '선택한 재료',
  recommend: '추천요리',
  title_detail: '추천 레시피',
  share: '공유',
  ingredients: {
    title: `<span class="tracking-tighter whitespace-nowrap">재료</span> <span class="tracking-tighter whitespace-nowrap">(1인분)</span>`,
    add_all: '재료 모두 추가',
    view_more: '{number}개의 재료 더보기',
    view_less: '접기',
    delete_all: '식재료 모두 삭제',
  },
  how_to_cook: '조리 방법',
  video: {
    title: '동영상 레시피',
  },
  msg: {
    msg_1: "해당 재료를 삭제하시겠습니까?",
    msg_2: "재료를 모두 삭제하시겠습니까?",
    msg_3: "해당 식재료를 추가 하시겠습니다?",
    msg_4: "부족한 식재료를 모두 추가 하시겠습니까?",
    msg_5: "선택한 재료를 장바구니에 추가 하시겠습니까?",
    msg_6: "해당 식재료는 이미 장바구니에 있습니다.",
    confirm: "예",
    cancel: "아니요",
  },
  recipe_exist_in_cart:"해당 식재료는 이미 장바구니에 있습니다.",
  recipe_want_add_to_cart:"선택한 재료를 장바구니에 추가 하시겠습니까?",
  recipe_exist_in_cart_should_exclued:"은(는) 현재 장바구니에 이미 있어 제외되었습니다.",
  calories_description: "이 음식은 아래 레시피를 기준으로 {calories}를 제공합니다. 건강에 맞는 선택을 고려해 주세요!",
  title_share_sns: "이 레시피를 공유하세요",
  copy: "복사",
  recipe_add_cart_success: "선택한 재료가 장바구니에 추가 되었습니다. 장바구니 화면으로 이동 하시겠습니까?  ",
  recipe_close: "닫기",
  recipe_move: "이동",
  recipe_add_ingredient_success: "선택한 재료가 추가 되었습니다. 식재료 화면으로 이동 하시겠습니까?",
  copied: "복사됨",
  text_share_sns: `{recipe_name} 이 레시피 어때요?\nHey! Cooker에서 확인해 보세요!`,
  search:{
    title: "레시피 검색",
    searching: "Hey Cooker는 당신의 키워드에 맞는 레시피를 찾고<br/> 있습니다. 잠시만 기다려 주세요!",
    not_found: "음... AI 쉐프가 당신의 키워드에 맞는 요리를 찾지<br/> 못했습니다. 다른 요리명을 입력해 보세요!",
    placeholder: "검색하려는 레시피 이름을 입력하세요...",
    msg_default_recipe: "아직 레시피가 없습니다",
  },
  noData: "결과를 찾을 수 없습니다",
  searching: "검색 중입니다..."
}
